export default __webpack_public_path__ + "static/media/agency.5de67d32.svg";